import { render } from "./SlotsPanel.vue?vue&type=template&id=f22463fe&scoped=true"
import script from "./SlotsPanel.vue?vue&type=script&lang=js"
export * from "./SlotsPanel.vue?vue&type=script&lang=js"

import "./SlotsPanel.vue?vue&type=style&index=0&id=f22463fe&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f22463fe"]])

export default __exports__